export const TRADE_LIST_LOADING_ACTION_RESET = 'TRADE_LIST_LOADING_ACTION_RESET';
export const TRADE_LIST_LOADING_ACTION_INITIATE = 'TRADE_LIST_LOADING_ACTION_INITIATE';
export const TRADE_LIST_LOADING_ACTION_METERS_LOADED = 'TRADE_LIST_LOADING_ACTION_METERS_LOADED';
export const TRADE_LIST_LOADING_ACTION_RULES_LOADED = 'TRADE_LIST_LOADING_ACTION_RULES_LOADED';
export const TRADE_LIST_LOADING_ACTION_TRADES_LOADED = 'TRADE_LIST_LOADING_ACTION_TRADES_LOADED';
export const TRADE_LIST_LOADING_ACTION_DATA_PREPARED = 'TRADE_LIST_LOADING_ACTION_DATA_PREPARED';
export const TRADE_LIST_LOADING_ACTION_DATA_RENDERED = 'TRADE_LIST_LOADING_ACTION_DATA_RENDERED';
export const TRADE_LIST_LOADING_ACTION_HIDE_OVERLAY = 'TRADE_LIST_LOADING_ACTION_HIDE_OVERLAY';
export const TRADE_LIST_LOADING_ACTION_RAISE_ERROR = 'TRADE_LIST_LOADING_ACTION_RAISE_ERROR';

export const TradeListLoadingActions = Object.freeze({
  RESET: TRADE_LIST_LOADING_ACTION_RESET,
  INITIATE: TRADE_LIST_LOADING_ACTION_INITIATE,
  METERS_LOADED: TRADE_LIST_LOADING_ACTION_METERS_LOADED,
  RULES_LOADED: TRADE_LIST_LOADING_ACTION_RULES_LOADED,
  TRADES_LOADED: TRADE_LIST_LOADING_ACTION_TRADES_LOADED,
  DATA_PREPARED: TRADE_LIST_LOADING_ACTION_DATA_PREPARED,
  DATA_RENDERED: TRADE_LIST_LOADING_ACTION_DATA_RENDERED,
  HIDE_OVERLAY: TRADE_LIST_LOADING_ACTION_HIDE_OVERLAY,
  RAISE_ERROR: TRADE_LIST_LOADING_ACTION_RAISE_ERROR,
});

const TRADE_LIST_LOADING_STATE_IDLE = 'TRADE_LIST_LOADING_STATE_IDLE';
const TRADE_LIST_LOADING_STATE_INITIALISING = 'TRADE_LIST_LOADING_STATE_INITIALISING';
const TRADE_LIST_LOADING_STATE_LOADING_METERS = 'TRADE_LIST_LOADING_STATE_LOADING_METERS';
const TRADE_LIST_LOADING_STATE_LOADING_RULES = 'TRADE_LIST_LOADING_STATE_LOADING_RULES';
const TRADE_LIST_LOADING_STATE_LOADING_TRADES = 'TRADE_LIST_LOADING_STATE_LOADING_TRADES';
const TRADE_LIST_LOADING_STATE_PREPARING_DATA = 'TRADE_LIST_LOADING_STATE_PREPARING_DATA';
const TRADE_LIST_LOADING_STATE_RENDERING_DATA = 'TRADE_LIST_LOADING_STATE_RENDERING_DATA';
const TRADE_LIST_LOADING_STATE_COMPLETE = 'TRADE_LIST_LOADING_STATE_COMPLETE';
const TRADE_LIST_LOADING_STATE_ERROR = 'TRADE_LIST_LOADING_STATE_ERROR';

/**
 * Enumerated loading states for the TradeList data pipeline.
 *
 * The pipeline progresses through the following conceptual stages:
 * - idle:            No request has been made yet
 * - initialising:    A new three-stage fetch has been initiated
 * - loading meters:  Meters are loading
 * - loading rules:   Trade rules are being fetched
 * - loading trades:  Trades are being fetched
 * - preparing data:  All raw data has been loaded and is being prepared
 * - rendering data:  Data is prepared and is now being rendered
 * - complete:        Loading is complete
 * - error:           An error occurred during any stage of the pipeline
 */
export const TradeListLoadingStates = Object.freeze({
  IDLE: TRADE_LIST_LOADING_STATE_IDLE,
  INITIALISING: TRADE_LIST_LOADING_STATE_INITIALISING,
  LOADING_METERS: TRADE_LIST_LOADING_STATE_LOADING_METERS,
  LOADING_RULES: TRADE_LIST_LOADING_STATE_LOADING_RULES,
  LOADING_TRADES: TRADE_LIST_LOADING_STATE_LOADING_TRADES,
  PREPARING_DATA: TRADE_LIST_LOADING_STATE_PREPARING_DATA,
  RENDERING_DATA: TRADE_LIST_LOADING_STATE_RENDERING_DATA,
  COMPLETE: TRADE_LIST_LOADING_STATE_COMPLETE,
  ERROR: TRADE_LIST_LOADING_STATE_ERROR,
});
